function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15.7a3.006 3.006 0 00-2.905 2.25H6.75a3 3 0 010-6h9a3.75 3.75 0 100-7.5h-9a.75.75 0 100 1.5h9a2.25 2.25 0 010 4.5h-9a4.5 4.5 0 100 9h9.095a3 3 0 102.905-3.75z",
    fill: props.fill
  }));
}

export default SvgPath;